export default {
    createUserDocumentForDate: '/userLogger/createUserDocumentForDate',
    getSpecificUserLogs: '/userLogger/getSpecificUserLogs',
  }